__webpack_require__.p = "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/_next/";